import React from "react";
import { Modal } from "react-bootstrap";
import CloseButton from "react-bootstrap/CloseButton";
import "./style.scss";
import CommonButton from "../../commonButton";

const LeaveConfirmationModal = ({ show, onHide, onLeave }) => {
  return (
    <Modal show={show} centered onHide={onHide} className="sm-modal">
      <Modal.Header className="rename-modal-header">
        <div className="form-modal">
          <Modal.Title>Leave this page?</Modal.Title>
        </div>
        <CloseButton onClick={onHide} className="close-cta-wrapper" />
      </Modal.Header>
      <Modal.Body className="clear-modal-wrapper">
        <p>
          You've made changes that haven't been saved. Do you want to leave without saving?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <CommonButton
          onClick={onHide}
          variant="secondary"
          btnText="DON'T LEAVE"
        />
        <CommonButton
          onClick={onLeave}
          variant="primary"
          btnText="LEAVE WITHOUT SAVING"
        />
      </Modal.Footer>
    </Modal>
  );
};

export default LeaveConfirmationModal;
